module.exports = __webpack_public_path__ + "img/class.a8837d3c.jpg";